<suvo-bi-navigation-outlet #navigationOutlet [noMenuButton]="true">
  <ng-container mainContent>
    <div class="expand main-content d-flex fd-col">
      <router-outlet></router-outlet>
      <!-- <app-customer-footer class="behind flex-1 d-flex jc-center ai-end"></app-customer-footer> -->
    </div>
  </ng-container>

  <ng-container leftSidenav>
    <app-main-sidenav></app-main-sidenav>
  </ng-container>
</suvo-bi-navigation-outlet>
